import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import groupBy from 'lodash/groupBy';
import Each from 'lodash/each';
import toArray from 'lodash/toArray';
import Keys from 'lodash/keys';
import Axios from 'axios';
import './MobileMenu.scss';
declare var jQuery: any;
//declare var jquery: any;
//declare var $: JQueryStatic;

//import $ from 'jquery';
//window.jQuery = $;
//window.$ = $;

class MobileMenu extends Component {
  
  constructor(props) {
      super(props);
      var data = { }
	   this.menu_data = toArray(data);
   	this.state = {
         cssDirection: 'forward',
         numberOfSlidesToShow: 1, 
   		slides: [
            { 
               link: {},
               below: []
            },
            { 
               link: {},
               below: toArray(data)
            }
         ],
         menu_data: {
            link: {},
            below: toArray(data),
         }
   	}

      this.getMenuData();
      jQuery(this.props.data.trigger).each((key,item)=>{
         jQuery(item).click(() => {
            this.toggleMenu();
         });
      });

   }	

   toggleMenu() {
      let mobileNav = jQuery('.mobile-nav');
      if(mobileNav.hasClass('open')) {
         mobileNav.removeClass('open');
      } else {
         mobileNav.addClass('open')
      }

   }

   getMenuData() {
      let menuName = 'main-menu';
      if(this.props.data.menuName) {
        menuName = this.props.data.menuName;
      }
      let mainNavEndpoint = '/menu-api/'+menuName;
      if(this.props.data.siteId) {
         mainNavEndpoint = '/'+this.props.data.siteId+'/menu-api/main-menu';
      }
      Axios.get(mainNavEndpoint).then((result) => {
         var data = result.data;
         this.setState({
            slides: [
               { 
                  link: {},
                  below: []
               },
               { 
                  link: {},
                  below: toArray(data)
               }
            ],
            menu_data: {
               link: {},
               below: toArray(data),
            }
         });
      })
   }

   getParentItemInTree(element, mlid, parent = false){
      
      if(element.link.mlid == mlid){
          return parent;
      }else if (toArray(element.below).length){
          var i;
          var result = null;
          var data = toArray(element.below);
          for(i=0; result == null && i < data.length; i++){
               result = this.getParentItemInTree(data[i],  mlid, element);
          }
          return result;
      }
      return null;
   }

   backMenu(e) {
      let parentMenu = this.getParentItemInTree(this.state.menu_data, this.state.slides[this.state.slides.length-1].link.mlid);
      //can do something with parentmenu beside just pop the array below. if needed

      let slides = this.state.slides;
      //let popped = slides.pop();
      this.setState({ 
            cssDirection: 'backward start'
         }, () => {
            setTimeout(() => { 
               let popped = slides.pop();
               this.setState({ 
                  cssDirection: 'backward end',
                  slides: slides
               }, () => {

               });
            }, 300)
           
         });
      e.stopPropagation();
   }
   openMenu(openMenu, e) {
     	openMenu.below = toArray(openMenu.below);
      let slides = this.state.slides;
      slides.push(openMenu);
      this.setState({ 
            cssDirection: 'forward start',
            slides: slides
         }, () => {
            setTimeout(() => { 
               this.setState({ 
                  cssDirection: 'forward end'
               }, () => {

               });
            }, 0)
           
         });
      e.stopPropagation();
   }


   renderToggleRight(mdata) {
     	if(toArray(mdata.below).length) { 
     		return  (
              <span className="submenu-toggle"  onClick={(e) => this.openMenu(mdata, e)}/>
            );
     	} else {
     		return null;
     	}
   }


   renderBackSlideRow(selectedMenu) {
      if(selectedMenu.link.hidden === "0") {
        if(selectedMenu.link.title) {
          if(selectedMenu.link.link_path !== '<nolink>' && selectedMenu.link.link_path !== '#') {
            return (<li className="back-btn">
                       <span className="submenu-toggle-back"  onClick={(e) => this.backMenu(e)}></span>
                       <a 
                          href={selectedMenu.link.alias_url} className="mobile-menu-alt-submenu-toggle">
                             {selectedMenu.link.title}
                       </a>
                   </li>);
          } else {
            return (<li className="back-btn">
                       <span className="submenu-toggle-back"  onClick={(e) => this.backMenu(e)}></span>
                       <a 
                          onClick={(e) => this.backMenu(e)} className="mobile-menu-alt-submenu-toggle">
                             {selectedMenu.link.title}
                       </a>
                   </li>);
          }

        } else {
           return null;
        }
      } else {
        return null;
      }
   }

   renderLink(menuitem) {
    if(menuitem.link.hidden === "0") {
      if(menuitem.link.link_path !== '<nolink>' && menuitem.link.link_path !== '#') {
        let url = menuitem.link.alias_url;
        if(!menuitem.link.alias_url) {
          url = menuitem.link.link_path;
        }

        return (
          <span>
            <a href={url} className="mobile-menu-alt-submenu-toggle">{menuitem.link.title}</a>
              {this.renderToggleRight(menuitem)}
          </span>
        );
      } else {
        return (
          <span>
            <a onClick={(e) => this.openMenu(menuitem, e)} className="mobile-menu-alt-submenu-toggle">{menuitem.link.title}</a>
              {this.renderToggleRight(menuitem)}
          </span>
        );
      }
    } else {
      return null;
    }
      
   }  

   renderSlides() {
      let display_slides = this.state.slides.slice(-(this.state.numberOfSlidesToShow+1));

      return (
        <div className={ 'transition_direction_'+this.state.cssDirection }>
          {display_slides.map((slide,slide_index) =>
             <div key={slide_index} className={ 'slide ' + 'slide_index_'+slide_index }>
                <ul className="menu">
                  {this.renderBackSlideRow(slide)}
                  {slide.below.map((d,i) =>
                  <li key={d.link.mlid}>
                    {this.renderLink(d)}
                  </li>
                  )}
                </ul>
             </div>
          )}

        </div>
      );
   }

   render() {
      return (
         <nav className={ 'navigation-mobile'}>
	        { this.renderSlides() }
      	</nav>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/MobileMenu/MobileMenu.js